'use strict';

exports.__esModule = true;
exports.onRequestError = exports.onRequestEnd = exports.onRequestStart = exports.doRequest = exports.mockXHR = exports.setCookies = undefined;

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mock = null;
var _cookies = {};
var requestCounter = 1;
var is_node = typeof process !== 'undefined' && process.title && process.title.toLowerCase().indexOf('node') !== -1;

var events = {
    start: [],
    end: [],
    error: []
};

exports.setCookies = setCookies;
exports.mockXHR = mockXHR;
exports.doRequest = doRequest;
exports.onRequestStart = onRequestStart;
exports.onRequestEnd = onRequestEnd;
exports.onRequestError = onRequestError;


function serverExec(url, payload, cb, error) {
    var opts = {
        url: url,
        method: 'post',
        json: JSON.parse(payload),
        timeout: 10 * 1000,
        headers: {
            'Content-Type': 'application/json'
        }
    };

    var jar = _request2.default.jar();

    for (var domain in _cookies) {
        var cookies = _cookies[domain];
        for (var name in cookies) {
            var cookie = _request2.default.cookie(name + '=' + cookies[name]);
            jar.setCookie(cookie, domain);
        }
    }

    opts.jar = jar;

    var requestNum = requestCounter;
    requestCounter++;
    (0, _request2.default)(opts, function (err, httpResponse, body) {
        if (err) {
            error(err);
        }

        var response = void 0;

        try {
            response = JSON.parse(body);
        } catch (e) {
            response = body;
        }

        cb(response);
    });
}

function exec(url, payload, cb, error) {
    var xhr = new XMLHttpRequest();

    xhr.open('POST', url);

    xhr.withCredentials = true;
    xhr.setRequestHeader('Content-Type', 'application/json');

    events.start.forEach(function (cb) {
        return cb(url, payload, xhr);
    });

    xhr.onload = function () {
        var json = void 0;
        try {
            json = JSON.parse(xhr.responseText);
        } catch (e) {
            json = null;
        }

        events.end.forEach(function (cb) {
            return cb(json, xhr);
        });
        cb(json);
        xhr = null;
    };
    // xhr.timeout = 10 * 1000;
    xhr.onerror = function (e) {
        var E = {
            message: 'Request Error',
            xhr: xhr,
            event: e
        };
        events.error.forEach(function (cb) {
            return cb(E, xhr);
        });
        error && error(E);
    };

    xhr.send(payload);

    return function stop() {
        if (xhr) xhr.abort();
        xhr = null;
    };
}

function setCookies(domain, cookies) {
    _cookies[domain] = cookies;
}

function mockXHR(fn) {
    mock = fn;
}

function doRequest(url, payload, cb, error) {
    if (mock) {
        return mock(url, payload, cb, error);
    } else if (is_node) {
        return serverExec(url, payload, cb, error);
    } else {
        return exec(url, payload, cb, error);
    }
}

function onRequestStart(cb) {
    events.start.push(cb);
}

function onRequestEnd(cb) {
    events.end.push(cb);
}

function onRequestError(cb) {
    events.error.push(cb);
}


//////////////////
// WEBPACK FOOTER
// ./~/@chegg/odin-concat/dist/request.js
// module id = 197
// module chunks = 0